import useSWR from "swr";
import { listMappingsForClient } from "./service";
import { UseMdaSpreadsheetMappingsModel } from "./types";

const useMdaSpreadsheetMappings = (
  clientId: number | null,
): UseMdaSpreadsheetMappingsModel => {
  const { data, error, isLoading, mutate } = useSWR(
    clientId !== null ? `/mda/spreadsheet/mappings/client/${clientId}` : null,
    () => listMappingsForClient(clientId as number),
  );

  return {
    data,
    isLoading,
    error,
    mutate,
  };
};

export default useMdaSpreadsheetMappings;
